// A sheet opened from anywhere (the job sheet, the invoice sheet, selling a membership) holds one
// opening at a time. Each opening is its own: a dialog's close event lands a task after close(),
// so closing a sheet and opening the same one again at once must not let the old close shut the new
// one. A counter, not the clock: two openings in one millisecond are still two.

let seq = 0;

export interface Slot<T> {
  value: T;
  at: number;
}

export const openSlot = <T>(value: T): Slot<T> => ({ value, at: ++seq });

/** The opening `at` closed: gone if it's still the one open; a later opening stays. */
export const closeSlot = <T>(current: Slot<T> | null, at: number): Slot<T> | null =>
  current?.at === at ? null : current;

/**
 * Calls `leave` when the address moves under a sheet: Back or Forward, a link followed, a hash typed
 * (history fix 4, 22 Oct: Back left an invoice open over the page it came from). The app's own marks
 * (history.replaceState) fire neither event, so a sheet stays while its page is open. Returns what
 * stops listening.
 */
export function onLeave(
  target: Pick<EventTarget, 'addEventListener' | 'removeEventListener'>,
  leave: () => void,
): () => void {
  target.addEventListener('popstate', leave);
  target.addEventListener('hashchange', leave);
  return () => {
    target.removeEventListener('popstate', leave);
    target.removeEventListener('hashchange', leave);
  };
}
